<template>
    <wrapper>
        <main class="main-content-wrapper">
            <card>
                <div>
                    <h5 class="form-title">Buat Baru</h5>
                    <p class="form-subtitle">Silahkan lengkapi rincian item atau barang yang akan dilakukan klaim service.</p>
                </div>

                <div class="form-sections-box">
                    <div class="vendor-section">
                        <div class="section-header">INFORMASI VENDOR</div>
                        <div class="section-body">
                            <single-select-v2
                                label="Nama Vendor"
                                placeholder="Pilih Vendor"
                                :value="vendorName"
                                :options="vendorOptions"
                                @change="vendorName = $event"
                                @search="onSearchVendor"
                            />
                        </div>
                    </div>

                    <div
                        v-for="(item, index) in items"
                        :key="`item-${index}`"
                        class="item-section"
                    >
                        <div class="section-header d-flex justify-content-between align-items-center">
                            <span>ITEM {{ index + 1 }}</span>
                            <button
                                v-if="items.length > 1"
                                type="button"
                                class="remove-item-btn"
                                @click="removeItem(index)"
                            >Hapus</button>
                        </div>
                        <div class="section-body">
                            <single-select-v2
                                label="Nama Item"
                                placeholder="Pilih item"
                                :value="item.itemId"
                                :options="itemOptions"
                                @change="onSelectItem(index, $event)"
                                @search="onSearchItem"
                            />
                            <div class="mt-3">
                                <single-select-v2
                                    label="Serial Number/Batch Number (jika ada)"
                                    placeholder="Masukan serial number/batch number"
                                    :value="item.serialNumber || item.batchNumber"
                                    :options="getAvailableSerialNumberOptions(index)"
                                    :disabled="!getAvailableSerialNumberOptions(index).length"
                                    @change="onSelectSerialNumber(index, $event)"
                                />
                            </div>
                        </div>
                    </div>

                    <div class="tambah-item-wrapper" v-if="items.length < 10">
                        <button type="button" class="tambah-item-btn" @click="addItem()">
                            + Tambah Item
                        </button>
                    </div>
                </div>
            </card>

            <div class="mt-3 d-flex justify-content-between">
                <button class="btn btn-outline-secondary back-btn" @click="$router.back()">
                    &#8592; Kembali
                </button>
                <button
                    class="btn btn-primary submit-btn"
                    :disabled="!isFormComplete || loadingSubmit"
                    @click="createService()"
                >
                    <img src="~@/assets/images/2.gif" style="height: 24px" v-if="loadingSubmit" />
                    {{loadingSubmit ? 'Menyimpan...' : 'Simpan'}}
                </button>
            </div>
        </main>
    </wrapper>
</template>

<script>
import Swal from "sweetalert2";
import { Wrapper, Card } from '../Layout';
import { SingleSelectV2 } from '../Input';

export default {
    name: 'ServiceCreationPage',
    components: {
        Wrapper,
        Card,
        SingleSelectV2,
    },
    data() {
        return {
            loadingSubmit: false,
            vendorName: '',
            vendorOptions: [],
            itemOptions: [],
            itemRawList: [],
            itemCache: {},
            items: [
                this.createEmptyItem(),
            ],
        };
    },
    computed: {
        isFormComplete() {
            return (
                this.vendorName !== '' &&
                this.items.length > 0 &&
                this.items.every((item) => {
                    if (item.itemId === '') return false;
                    if ((item.hasSerialNo || item.hasBatchNo) && !item.serialNumber && !item.batchNumber) return false;
                    return true;
                })
            );
        },
    },
    methods: {
        createEmptyItem() {
            return {
                itemId: '',
                itemCode: '',
                itemName: '',
                itemGroup: '',
                warehouse: '',
                hasSerialNo: false,
                hasBatchNo: false,
                serialBatchDetails: [],
                serialNumberOptions: [],
                serialNumber: '',
                batchNumber: '',
            };
        },
        cekPermission() {
            this.permission = localStorage.getItem('roles').replace(/"/g, "").replace("[", "").replace("]", "").split(",")
            if(!this.permission.includes('27.3')) {
                this.$router.push('/');
            }
        },
        getVendorList(keyword = '') {
            const swalWithBootstrapButtons = Swal.mixin({
                customClass: {
                confirmButton: "btn btn-primary ml-2",
                cancelButton: "btn btn-danger",
                },
                buttonsStyling: false,
            });

            this.$http.post(process.env.SERVICE_GET_VENDORS, {
                keyword : keyword
            },{
                headers: { 'Asani-Token': localStorage.getItem('jwt') },
            })
            .then((response) => {
                if(response.status !== 200 || response.data.status !== 200) {
                    swalWithBootstrapButtons.fire({
                        title: "Failed",
                        text: `${response.data.message ? response.data.message : response.message}`,
                        icon: "error",
                    })
                } else {
                    this.vendorOptions = response.data.data.vendors.map((vendor) => ({
                        label: vendor,
                        value: vendor,
                    }));
                }
            })
        },
        onSearchVendor(keyword) {
            this.getVendorList(keyword);
        },
        getItemList(keyword = '') {
            const swalWithBootstrapButtons = Swal.mixin({
                customClass: {
                confirmButton: "btn btn-primary ml-2",
                cancelButton: "btn btn-danger",
                },
                buttonsStyling: false,
            });

            this.$http.post(process.env.SERVICE_GET_ITEMS,{
                name : keyword,
                page : 1,
                itemPerPage : 30,
            },{
                headers: { 'Asani-Token': localStorage.getItem('jwt') },
            })
            .then((response) => {
                if(response.status !== 200 || response.data.status !== 200) {
                    swalWithBootstrapButtons.fire({
                        title: "Failed",
                        text: `${response.data.message ? response.data.message : response.message}`,
                        icon: "error",
                    })
                } else {
                    const latestItems = response.data.data.data;
                    latestItems.forEach((item) => {
                        this.itemCache[this.getItemKey(item)] = item;
                    });

                    const selectedKeysNotInLatest = this.items
                        .map((item) => item.itemId)
                        .filter((key) => key && !latestItems.some((item) => this.getItemKey(item) === key));

                    const preservedSelectedItems = selectedKeysNotInLatest
                        .map((key) => this.itemCache[key])
                        .filter(Boolean);

                    const combined = [...latestItems, ...preservedSelectedItems];
                    this.itemRawList = combined;
                    this.itemOptions = combined.map((item) => ({
                        label: `${item.itemName} (${item.warehouse})`,
                        value: this.getItemKey(item),
                    }));
                }
            })
        },
        onSearchItem(keyword) {
            this.getItemList(keyword);
        },
        addItem() {
            this.items.push(this.createEmptyItem());
        },
        removeItem(index) {
            this.items.splice(index, 1);
        },
        buildSerialNumberOptions(selectedItem) {
            return (selectedItem.serialBatchDetails || []).map((detail) => {
                const parts = [];
                if (selectedItem.hasSerialNo && detail.serialNumber) {
                    parts.push(`SN: ${detail.serialNumber}`);
                }
                if (selectedItem.hasBatchNo && detail.batchNumber) {
                    parts.push(`Batch: ${detail.batchNumber}`);
                }
                return {
                    label: parts.join(' / ') || detail.stockCode,
                    value: detail.serialNumber ? detail.serialNumber : detail.batchNumber ,
                };
            });
        },
        getAvailableSerialNumberOptions(index) {
            const currentItem = this.items[index];
            if (!currentItem.serialNumberOptions.length) return [];

            const usedByOtherItems = this.items
                .filter((otherItem, otherIndex) => otherIndex !== index
                    && otherItem.itemCode === currentItem.itemCode
                    && (otherItem.serialNumber || otherItem.batchNumber))
                .map((otherItem) => otherItem.serialNumber || otherItem.batchNumber);

            return currentItem.serialNumberOptions.filter(
                (option) => !usedByOtherItems.includes(option.value)
            );
        },
        onSelectSerialNumber(index, value) {
            const currentItem = this.items[index];
            const selectedDetail = (currentItem.serialBatchDetails || []).find(
                (detail) => (detail.serialNumber ? detail.serialNumber : detail.batchNumber) === value
            ) || {};

            currentItem.serialNumber = selectedDetail.serialNumber || '';
            currentItem.batchNumber = selectedDetail.batchNumber || '';
        },
        getItemKey(item) {
            return `${item.itemCode}__${item.warehouse}`;
        },
        onSelectItem(index, value) {
            const selectedItem = this.itemRawList.find((item) => this.getItemKey(item) === value) || {};
            this.items.splice(index, 1, {
                ...this.createEmptyItem(),
                itemId: value,
                itemCode: selectedItem.itemCode || value,
                itemName: selectedItem.itemName || '',
                itemGroup: selectedItem.itemGroup || '',
                warehouse: selectedItem.warehouse || '',
                hasSerialNo: !!selectedItem.hasSerialNo,
                hasBatchNo: !!selectedItem.hasBatchNo,
                serialBatchDetails: selectedItem.serialBatchDetails || [],
                serialNumberOptions: this.buildSerialNumberOptions(selectedItem),
            });
        },
        createService() {
            const swalWithBootstrapButtons = Swal.mixin({
                customClass: {
                confirmButton: "btn btn-primary ml-2",
                cancelButton: "btn btn-danger",
                },
                buttonsStyling: false,
            });

            if (!this.isFormComplete || this.loadingSubmit) return;
            this.loadingSubmit = true;
            this.$http
                .post(
                    process.env.SERVICE_SAVE,
                    {
                        serviceId : 0,
                        vendorName: this.vendorName,
                        stage: 'draft',
                        items: this.items.map((item) => {
                            const selectedDetail = (item.serialBatchDetails || []).find(
                                (detail) => (item.serialNumber && detail.serialNumber === item.serialNumber)
                                    || (item.batchNumber && detail.batchNumber === item.batchNumber)
                            ) || {};
                            return {
                                id : 0, //service_detail_id dari detail
                                itemCode: Number(item.itemCode) ,
                                itemName : item.itemName,
                                itemGroup : item.itemGroup,
                                warehouseLocation : item.warehouse,
                                serialNumber: selectedDetail.serialNumber,
                                cfSerialNumber : selectedDetail.cfSerialNumber,
                                batchNumber: selectedDetail.batchNumber,
                                stockCode : selectedDetail.stockCode,
                                resolutionMethod : '',
                            };
                        }),
                    },
                    {
                        headers: { 'Asani-Token': localStorage.getItem('jwt') },
                    }
                )
                .then((response) => {
                    this.loadingSubmit = false;
                    if (response.data.status === 200) {
                        swalWithBootstrapButtons.fire({ title: 'Success', text: 'Berhasil membuat servis baru', icon: 'success' }).then(() => {
                            this.$router.push('/service');
                        });  
                    } else {
                        swalWithBootstrapButtons.fire({ title: 'Sorry', text: response.data.message, icon: 'error' });
                    }
                })
                .catch((error) => {
                    this.loadingSubmit = false;
                    swalWithBootstrapButtons.fire({ title: 'Sorry', text: error.response.data.message, icon: 'error' }).then(() => {
                        if (error.response.data.status === 401) {
                            this.handleLogout();
                        }
                    });
                });
        },
        async handleLogout() {
            try {
                await this.$http.post(process.env.LOGOUT, {}, {
                    headers: { 'Asani-Token': localStorage.getItem('jwt') },
                });
            } catch (error) {
                if (error.response.data.status !== 401) return;
            }
            localStorage.removeItem('jwt');
            localStorage.removeItem('admin_name');
            localStorage.removeItem('roles');
            localStorage.removeItem('user_email');
            localStorage.removeItem('admin_id');
            this.$router.push('/');
        },
        cekLogin() {
            if (localStorage.getItem('jwt') == null) {
                this.$router.push('/');
            }
        },
    },
    created() {
        this.cekLogin();
        this.cekPermission();
        this.getVendorList()
        this.getItemList()
    },
};
</script>

<style scoped>
.main-content-wrapper {
    padding: 24px;
}

.form-title {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 4px;
    color: #212529;
}

.form-subtitle {
    font-size: 13px;
    color: #6c757d;
    margin-bottom: 0;
}

.form-sections-box {
    border: 1px solid #e9ecef;
    border-radius: 8px;
    margin-top: 20px;
}

.form-sections-box > div + div {
    border-top: 1px solid #e9ecef;
}

.form-sections-box > div:first-child > .section-header {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
}

.section-header {
    background: #f8f9fa;
    padding: 10px 20px;
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    color: #495057;
}

.remove-item-btn {
    border: none;
    background: none;
    color: #dc3545;
    font-size: 12px;
    font-weight: 600;
    text-transform: none;
    letter-spacing: normal;
    padding: 0;
}

.section-body {
    padding: 20px;
}

.tambah-item-wrapper {
    padding: 16px 20px;
}

.tambah-item-btn {
    width: 100%;
    background: #fff;
    border: 1px solid #d1d9e2;
    border-radius: 6px;
    color: #247fec;
    font-weight: 600;
    font-size: 14px;
    padding: 10px;
}

.tambah-item-btn:hover {
    background-color: #f0f4ff;
}

.back-btn {
    font-size: 13px;
    border-color: #dee2e6;
    color: #343a40;
    background: #fff;
    padding: 6px 16px;
}

.back-btn:hover {
    background-color: #f8f9fa;
}

.submit-btn {
    font-size: 13px;
    padding: 6px 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/Service/ServiceCreationPage.vue